import type { Execution, Order, Position } from "@ekidenfi/ts-sdk";

import { getEkidenSdkClient } from "@src/api/sdk";

export interface UserOrdersResult {
  orders: Order[];
  orderHistory: Order[];
  fills: Execution[];
  fillHistory: Execution[];
  positions: Position[];
  allPositions: Position[]; // All positions including size=0 (for leverage extraction)
}

export class OrderService {
  loadUserOrders = async (subAccountAddress: string, symbol?: string): Promise<UserOrdersResult> => {
    const ekidenSdkClient = getEkidenSdkClient();

    const [ordersRes, orderHistoryRes, fillsRes, fillHistoryRes, positionsRes] = await Promise.all([
      ekidenSdkClient.trade.getRealtimeOrders({ sub_account_address: subAccountAddress, symbol, open_only: true }),
      ekidenSdkClient.trade.getOrderHistory({ sub_account_address: subAccountAddress }),
      ekidenSdkClient.trade.getTradeHistory({ sub_account_address: subAccountAddress, symbol }),
      ekidenSdkClient.trade.getTradeHistory({ sub_account_address: subAccountAddress }),
      ekidenSdkClient.position.getPositionInfo({ sub_account_address: subAccountAddress, symbol }),
    ]);

    const allPositions = positionsRes.list;
    const nonZeroPositions = allPositions.filter((position: Position) => Number(position.size) !== 0);

    return {
      orders: ordersRes.list,
      orderHistory: orderHistoryRes.list,
      fills: fillsRes.list,
      fillHistory: fillHistoryRes.list,
      positions: nonZeroPositions,
      allPositions,
    };
  };
}

export const orderService = new OrderService();
